import { AfterViewInit, Component, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfigurationService } from './configuration.service';
import { NestedTreeControl } from '@angular/cdk/tree';
import { ConfigurationTreeDataModel } from './models/configuration-tree-data.model';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { AuthenticationService } from '../auth/services/authentication.service';
import { UserRoleEnum } from '../../models/enum/user-role.enum';



@Component({
  selector: 'app-configuration',
  templateUrl: './configuration.component.html',
  styleUrls: ['./configuration.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ConfigurationComponent implements OnInit, AfterViewInit {
  treeControl = new NestedTreeControl<ConfigurationTreeDataModel>(node => node.children);
  dataSource = new MatTreeNestedDataSource<ConfigurationTreeDataModel>();
  searchValue: string = '';
  selectedNode: ConfigurationTreeDataModel;
//  private readonly route = inject(ActivatedRoute);


  constructor(
    private readonly userConfigService: ConfigurationService, 
    private readonly router: Router, 
    private readonly authenticationService: AuthenticationService) {
    this.dataSource.data = this.userConfigService.configurationItems;
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      for (const ds of this.dataSource.data) {
        for (const d of ds.children) {
          d.isSelected = false;
        }
      }

      const loc = this.router.url;
      const endpoint = loc.substring(loc.lastIndexOf('/') + 1, loc.length);

      if (endpoint !== 'configuration') {
        for (const model of this.dataSource.data) {
          const currentModel = model.children.find(p => p.routerLink === endpoint);
          if (currentModel) {
            currentModel.isSelected = true;
            this.selectedNode = currentModel;
            this.treeControl.expand(model);
            break;
          }
        }
      } else {
        this.treeControl.expand(this.dataSource.data[0]);
      }
    }, 500);
  }

  ngOnInit() {

  }

  hasChild = (_: number, node: ConfigurationTreeDataModel) => !!node.children && node.children.length > 0;

  onChildClick(node: ConfigurationTreeDataModel) {
    if (!node.isEnabled || !this.isTreeItemEnabled(node.text)) {
      return;
    }

    if (this.selectedNode) {
      this.selectedNode.isSelected = false;
    }
    this.selectedNode = node;
    this.selectedNode.isSelected = true;
    if (node.routeType === 'configuration') {
      if (node.queryParams) {
        this.router.navigate(['/configuration/' + node.routerLink], {queryParams: node.queryParams}).then(r => {
          //
        });
      } else {
        this.router.navigateByUrl('/configuration/' + node.routerLink).then(r => {
          //
        });
      }
    } 
    else if (node.queryParams) {
        this.router.navigate([node.routerLink], { queryParams: node.queryParams }).then(r => {
          //
        });
      } 
    else {
        this.router.navigateByUrl(node.routerLink).then(r => {
          //
        });
      }
  }

  onInputChange() {
    if (this.searchValue === '') {
      this.dataSource.data = this.userConfigService.configurationItems;
      this.treeControl.dataNodes = this.dataSource.data;
      return;
    }

    const searchString = this.searchValue.toLowerCase();
    let searchModel: Array<ConfigurationTreeDataModel> = new Array<ConfigurationTreeDataModel>();
    for (const model of this.userConfigService.configurationItems) {
      if (model.children.length > 0) {
        const idx = model.children.findIndex(p => p.text.toLowerCase().includes(searchString) && p.isEnabled);
        if (idx > -1) {
          const newModel = new ConfigurationTreeDataModel(model.id, model.name, model.text, model.color, model.routerLink, model.iconPath);
          newModel.children = model.children.filter(p => p.text.toLowerCase().includes((searchString)) && p.isEnabled);
          searchModel.push(newModel);
        }
      }
    }
    searchModel = searchModel.concat(this.userConfigService.configurationItems.filter(p1 =>
      p1.text.toLowerCase().includes(searchString) && p1.children.length === 0));
    this.dataSource.data = searchModel;
    this.treeControl.dataNodes = this.dataSource.data;
    this.treeControl.expandAll();
  }

  onClearSearch() {
    this.dataSource.data = this.userConfigService.configurationItems;
    this.searchValue = '';
  }

  isTreeItemEnabled(name: string) {
    switch (name) {
      case 'Enterprise Information':
        if (this.authenticationService.currentUserRolesIds && this.authenticationService.currentUserRolesIds.length > 0) {
          if (this.authenticationService.currentUserRolesIds.includes(UserRoleEnum.AdministratorOfEnterprise)) {
            return true;
          }
        }
        return false;
      case 'Enterprise Practices':
      case 'User Groups':
        if (this.authenticationService.currentUserRolesIds && this.authenticationService.currentUserRolesIds.length > 0) {
          if (this.authenticationService.currentUserRolesIds.includes(UserRoleEnum.AdministratorOfPractice)) {
            return true;
          }
        }
        return false;
      default:
        return true;
    }
  }
}



